import { Crud } from '../common/Edit';

/**
 * UTM_WK_PROG_STAT_CD
 */
export enum UTMatrixWkProgStatCd {
  TEMP = 'UTM01', // 요청전
  WRITE = 'UTM02', // 작성중
  WRITE_COMPLETE = 'UTM03', // 작성완료
  REVIEW = 'UTM04', // 검토중
  REVIEW_COMPLETE = 'UTM07', // 검토완료
  COMPLETE = 'UTM05', //확정완료
  HOLD = 'UTM06', //보류
}

export interface UtMatrixMaster {
  utmId?: string; // 유틸리티매트릭스ID
  utmNo?: string; // 유틸리티매트릭스번호
  bildPlntCd?: string; // 건설플랜트코드
  bildPlntCdNm?: string; // 건설플랜트코드명
  askPurpCd?: string; // 의뢰목적코드
  askPurpCdNm?: string; // 의뢰목적코드명
  utmNm?: string; // 유틸리티매트릭스명
  verNo?: string; // 버전번호
  veupYn?: string; // 버전업여부
  utmWkProgStatCd?: string; // 유틸리티매트릭스작업진행상태코드
  utmWkProgStatCdNm?: string; // 유틸리티매트릭스작업진행상태코드명
  bfUtmWkProgStatCd?: string; // 이전유틸리티매트릭스작업진행상태코드
  bfUtmWkProgStatCdNm?: string; // 이전유틸리티매트릭스작업진행상태코드명
  wrtReqCtn?: string; // 작성요청내용
  rerqRsnCtn?: string; // 재요청사유내용
  curYn?: string; // 현재여부
  smitCloDtm?: string; // 제출마감일시
  planCpltDtm?: string; // 계획완료일시
  pfrsltCpltDtm?: string; // 실적완료일시
  procRatio?: string; // 진행공정
  aprRequest?: string; // 진행공정
  rmk?: string; // 비고
  delayCtn?: string; //지연
  atchFileGrId?: string; // 첨부파일그룹ID
  useYn?: string; // 사용여부
  optValCtn1?: string; // 옵션값내용1
  optValCtn2?: string; // 옵션값내용2
  optValCtn3?: string; // 옵션값내용3
  optValCtn4?: string; // 옵션값내용4
  optValCtn5?: string; // 옵션값내용5
  dataInsUserId?: string; // 데이터입력사용자ID
  dataInsUserNm?: string; // 데이터입력사용자명
  dataInsUserIp?: string;
  dataInsDtm?: string; // 데이터입력일시
  dataUpdUserId?: string; // 데이터수정사용자ID
  dataUpdUserNm?: string; // 데이터수정사용자명
  dataUpdUserIp?: string;
  dataUpdDtm?: string; // 데이터수정일시

  sendMailMsg?: string; //메일내용
  emlTpId?: string; //수신대상자
}

export interface UtMatrixDetail extends Crud {
  utmId?: string; // 유틸리티매트릭스ID
  planProcId?: string; // 계획공정ID
  utmSeq?: string; // 유틸리티매트릭스순번
  bizAreaNm?: string; // 사업영역명
  bldgFloCd?: string; // 건물층코드
  istlLocNm?: string; // 설치위치명
  stndEqpId?: string; // 표준설비ID
  prdnLnNm?: string; // 생산라인명
  prdnPrlLnNm?: string; // 생산병렬라인명
  eqpMainNm?: string; // 설비메인명
  eqpMchNm?: string; // 설비머신명
  eqpUntNm?: string; // 설비유닛명
  machEqpNm?: string; // 기계설비명
  elpwEqpNm?: string; // 전력설비명
  machEqpQty?: string; // 기계설비수량
  elpwEqpQty?: string; // 전력설비수량
  eqpDimWthLen?: string; // 설비디멘전가로길이
  eqpDimDpthNvl?: string; // 설비디멘전깊이값수치
  eqpDimHigtNvl?: string; // 설비디멘전높이값수치
  eqpWgt?: string; // 설비중량
  utmLibId?: string; // 유틸리티매트릭스라이브러리ID
  utmLibVerNo?: string; // 유틸리티매트릭스라이브러리버전번호
  insTpCd?: string; // 입력유형코드
  exlUpldUseYn?: string; // 엑셀업로드사용여부
  elpwEqpGrNm?: string; // 전력설비그룹명
  vltgNvl?: string; // 전압값수치
  elpwPhasCd?: string; // 전력위상코드
  ctwTpCd?: string; // 단선유형코드
  frqNvl?: string; // 빈도값수치
  pwftNvl?: string; // 역률값수치
  od1EcNvl?: string; // 1차전류값수치
  od2EcNvl?: string; // 2차전류값수치
  smtmOprt?: string; // 동시가동률
  brkeCapa?: string; // 차단기용량
  plcClctYn?: string; // PLC수집여부
  elpwEqpCnctTpCd?: string; // 전력설비연결유형코드
  elpwCapa?: string; // 전력용량
  elpwSumCapa?: string; // 전력집계용량
  elpwHeatCapa?: string; // 전력예열용량
  elpwEumMaxNvl?: string; // 전력실사용량(EUMPeak값)
  dmdElpwTarfNvl?: string; // 수요전력요율값수치
  dmdElpwCapa?: string; // 수요전력용량
  cdsCapa?: string; // 축전기용량
  elpwStndUseQty?: string; // 전력표준사용량
  cdaSize?: string; // 압축공기크기
  cdaOtsdSizeValCtn?: string; // 압축공기외부크기값내용
  cdaInsdSizeValCtn?: string; // 압축공기내부크기값내용
  cdaDevcCnctTpCd?: string; // 압출공기장치연결유형코드
  cdaPntCnt?: string; // 압축공기포인트건수
  cdaPres?: string; // 압축공기압력
  cdaPresValCtn?: string; // 압축공기압력값내용
  cdaCspCapa?: string; // 압축공기소비용량
  cdaCspSumCapa?: string; // 압축공기소비집계용량
  cdaStndUseQty?: string; // 압축공기표준사용량
  cdaEumMaxNvl?: string; // 압축공기실사용량(EUMPeak값)
  nitrSize?: string; // 질소크기
  nitrOtsdDmtrValCtn?: string; // 질소외부직경값내용
  nitrInsdDmtrValCtn?: string; // 질소내부직경값내용
  nitrDevcCnctTpCd?: string; // 질소장치연결유형코드
  nitrPntCnt?: string; // 질소포인트건수
  nitrPres?: string; // 질소압력
  nitrPresValCtn?: string; // 질소압력값내용
  nitrCspCapa?: string; // 질소소비용량
  nitrCspSumCapa?: string; // 질소소비집계용량
  nitrPeakCspCapa?: string; // 질소피크소비용량
  nitrPeakCspSumCapa?: string; // 질소피크소비집계용량
  nitrStndUseQty?: string; // 질소표준사용량
  iwSize?: string; // 공업용수크기
  iwOtsdDmtrValCtn?: string; // 공업용수외부직경값내용
  iwInsdDmtrValCtn?: string; // 공업용수내부직경값내용
  iwDevcCnctTpCd?: string; // 공업용수장치연결유형코드
  iwTmpr?: string; // 공업용수온도
  iwTmprValCtn?: string; // 공업용수온도값내용
  iwPres?: string; // 공업용수압력
  iwPresValCtn?: string; // 공업용수압력값내용 TOOD -
  iwPntCnt?: string; // 공업용수포인트건수
  iwDrnCapa?: string; // 공업용수배수구용량
  iwDrnSumCapa?: string; // 공업용수배수구집계용량
  iwCspCapa?: string; // 공업용수소비용량
  iwCspSumCapa?: string; // 공업용수소비집계용량
  iwStndUseQty?: string; // 공업용수표준사용량
  frwtSize?: string; // 소방용수크기
  frwtOtsdDmtrValCtn?: string; // 소방용수외부직경값내용
  frwtInsdDmtrValCtn?: string; // 소방용수내부직경값내용
  frwtDevcCnctTpCd?: string; // 소방용수장치연결유형코드
  frwtTmpr?: string; // 소방용수온도
  frwtTmprValCtn?: string; // 소방용수온도값내용
  frwtPres?: string; // 소방용수압력
  frwtPresValCtn?: string; // 소방용수압력값내용
  frwtPntCnt?: string; // 소방용수포인트건수
  frwtDrnCapa?: string; // 소방용수배수구용량
  frwtDrnSumCapa?: string; // 소방용수배수구집계용량
  frwtCspCapa?: string; // 소방용수소비용량
  frwtCspSumCapa?: string; // 소방용수소비집계용량
  frwtStndUseQty?: string; // 소방용수표준사용량
  coolSize?: string; // 냉각수크기
  coolOtsdSizeValCtn?: string; // 냉각수외부크기값내용
  coolInsdSizeValCtn?: string; // 냉각수내부크기값내용
  coolDevcCnctTpCd?: string; // 냉각수장치연결유형코드
  coolTmpr?: string; // 냉각수온도
  coolTmprValCtn?: string; // 냉각수온도값내용
  coolPres?: string; // 냉각수압력
  coolPresValCtn?: string; // 냉각수압력값내용
  coolPntCnt?: string; // 냉각수포인트건수
  coolCspCapa?: string; // 냉각수소비용량
  coolCspSumCapa?: string; // 냉각수소비집계용량
  coolStndUseQty?: string; // 냉각수표준사용량
  wwSize?: string; // 폐수크기
  wwOtsdDmtrValCtn?: string; // 폐수외부직경값내용
  wwInsdDmtrValCtn?: string; // 폐수내부직경값내용
  wwDevcCnctTpCd?: string; // 폐수장치연결유형코드
  wwTmpr?: string; // 폐수온도
  wwTmprValCtn?: string; // 폐수온도값내용
  wwPres?: string; // 폐수압력
  wwPresValCtn?: string; // 폐수압력값내용
  wwPntCnt?: string; // 폐수포인트건수
  wwCspCapa?: string; // 폐수소비용량
  wwCspSumCapa?: string; // 폐수소비집계용량
  wwStndUseQty?: string; // 폐수표준사용량
  stemSize?: string; // 스팀크기
  stemOtsdDmtrValCtn?: string; // 스팀외부직경값내용
  stemInsdDmtrValCtn?: string; // 스팀내부직경값내용
  stemDevcCnctTpCd?: string; // 스팀장치연결유형코드
  stemCwtSize?: string; // 스팀응축수크기
  stemCwtDevcCnctTpCd?: string; // 스팀응축수장치연결유형코드
  stemPres?: string; // 스팀압력
  stemPresValCtn?: string; // 스팀압력값내용
  stemPntCnt?: string; // 스팀포인트건수
  stemCspCapa?: string; // 스팀소비용량
  stemCspSumCapa?: string; // 스팀소비집계용량
  stemStndUseQty?: string; // 스팀표준사용량
  lngSize?: string; // 액화천연가스크기
  lngOtsdDmtrValCtn?: string; // 액화천연가스외부직경값내용
  lngInsdDmtrValCtn?: string; // 액화천연가스내부직경값내용
  lngDevcCnctTpCd?: string; // 액화천연가스장치연결유형코드
  lngTmpr?: string; // 액화천연가스온도
  lngTmprValCtn?: string; // 액화천연가스온도값내용
  lngPres?: string; // 액화천연가스압력
  lngPresValCtn?: string; // 액화천연가스압력
  lngPntCnt?: string; // 액화천연가스포인트건수
  lngCspCapa?: string; // 액화천연가스소비용량
  lngCspSumCapa?: string; // 액화천연가스소비집계용량
  lngStndUseQty?: string; // 액화천연가스표준사용량
  insdExhaSize?: string; // 내부배기크기
  exhaOtsdDmtrValCtn?: string; // 내부배기외부직경값내용
  insdExhaInsdDmtrValCtn?: string; // 내부배기내부직경값내용
  insdExhaCnctTpCd?: string; // 내부배기연결유형코드
  insdExhaCllrTpCd?: string; // 내부배기수집기유형코드
  insdExhaTmpr?: string; // 내부배기온도
  insdExhaTmprValCtn?: string; // 내부배기온도값내용
  insdExhaPntCnt?: string; // 내부배기포인트건수
  insdExhaCspCapa?: string; // 내부배기소비용량
  insdExhaCspSumCapa?: string; // 내부배기소비집계용량
  insdExhaStndUseQty?: string; // 내부배기표준사용량
  otsdExhaSize?: string; // 외부배기크기
  otsdExhaOtsdDmtrValCtn?: string; // 외부배기외부직경값내용
  otsdExhaInsdDmtrValCtn?: string; // 외부배기내부직경값내용
  otsdExhaCnctTpCd?: string; // 외부배기연결유형코드
  otsdExhaCllrTpCd?: string; // 외부배기수집기유형코드
  otsdExhaTmprValCtn?: string; // 외부배기온도값내용
  otsdExhaPntCnt?: string; // 외부배기포인트건수
  otsdExhaCspCapa?: string; // 외부배기소비용량
  otsdExhaCspSumCapa?: string; // 외부배기소비집계용량
  otsdExhaStndUseQty?: string; // 외부배기표준사용량
  suarSize?: string; // 급기크기
  suarOtsdDmtrValCtn?: string; // 급기외부직경값내용
  suarInsdDmtrValCtn?: string; // 급기내부직경값내용
  suarDevcCnctTpCd?: string; // 급기장치연결유형코드
  suarCllrTpCd?: string; // 급기수집기유형코드
  suarTmprValCtn?: string; // 급기온도값내용
  suarCnctCnt?: string; // 급기연결건수
  suarPntCnt?: string; // 급기포인트건수
  suarCspCapa?: string; // 급기소비용량
  suarCspSumCapa?: string; // 급기소비집계용량
  suarStndUseQty?: string; // 급기표준사용량

  vacmPumpSize?: string; // 진공펌프배기크기
  vacmPumpOtsdDmtrValCtn?: string; // 진공펌프외부직경값내용
  vacmPumpInsdDmtrValCtn?: string; // 진공펌프내부직경값내용
  vacmPumpCnctTpCd?: string; // 진공펌프연결유형코드
  vacmPumpCllrTpCd?: string; // 진공펌프수집기유형코드
  vacmPumpTmprValCtn?: string; // 진공펌프온도값내용
  vacmPumpTmpr?: string; // 진공펌프온도값내용
  vacmPumpPntCnt?: string; // 진공펌프포인트건수
  vacmPumpCspCapa?: string; // 진공펌프소비용량
  vacmPumpCspSumCapa?: string; // 진공펌프소비집계용량
  vacmPumpStndUseQty?: string; // 진공펌프표준사용량
  vacmPumpPres?: string; // 진공펌프압력
  vacmPumpValCtn?: string; // 진공펌프압력

  rmk?: string; // 비고
  atchFileGrId?: string; // 첨부파일그룹ID
  useYn?: string; // 사용여부
  optValCtn1?: string; // 옵션값내용1
  optValCtn2?: string; // 옵션값내용2
  optValCtn3?: string; // 옵션값내용3
  optValCtn4?: string; // 옵션값내용4
  optValCtn5?: string; // 옵션값내용5
  dataInsUserId?: string; // 데이터입력사용자ID
  dataInsUserIp?: string; // 데이터입력사용자IP주소
  dataInsDtm?: string; // 데이터입력일시
  dataUpdUserId?: string; // 데이터수정사용자ID
  dataUpdUserIp?: string; // 데이터수정사용자IP주소
  dataUpdDtm?: string; // 데이터수정일시

  prdnProcCd?: string; // 생산공정
  prdnProcCdNm?: string; // 생산공정명
  dtalProcCd?: string; // 세부공정
  dtalProcCdNm?: string; // 세부공정명
  bildPlntCd?: string; // 건설플랜트코드
  usNusType?: string; // US / NUS 구분
  eqpPrdnLnQty?: string; // 라인수

  elecDmdRate?: string; // Electrocity 수용율
  cdaDmdRate?: string; // CDA 수용율
  nitrDmdRate?: string; // N₂ Peak 수용율
  nitrAvgDmdRate?: string; // N₂ Avg 수용율
  iwDmdRate?: string; // IW 수용율
  frwtDmdRate?: string; // IW2 수용율
  coolDmdRate?: string; // PCW 수용율
  wwDmdRate?: string; // WW 수용율
  steamDmdRate?: string; // Steam 수용율
  lngDmdRate?: string; // NG 수용율
  insdExhaDmdRate?: string; // Ex.Return 수용율
  otsdExhaDmdRate?: string; // Ex.Vent 수용율
  suarDmdRate?: string; // Supply Air 수용율

  vacmPumpDmdRate?: string; // Vacuum Pump 수용율

  utmWrtProcProgStatCd?: string; // 유틸리티매트릭스작성공정진행상태코드
  utmWrtProcProgStatCdNm?: string; // 유틸리티매트릭스작성공정진행상태코드명

  utmWkProgStatCd?: string; // 유틸리티매트릭스작업진행상태코드(진척률 노출용)
  cmplCnt?: string; // 완료 건수(진척률 노출용)
  totalCnt?: string; // 전체 건수(진척률 노출용)
  delayCnt?: string; // 지연 건수(진척률 노출용)
  procPer?: string; // 진척률(진척률 노출용)
  utmWriteYn?: string; // 작성담당자여부
  tagIssuYn?: string; // Hookup Tagging 여부
  exctYn?: string; // 예외여부
  eqclId?: string; // 설비군ID
  eqclNm?: string; // 설비군명
}

/**
 * UtMatrix 작성 검색조건
 */
export interface UtMatrixRegistSearchCondition {
  utmWkProgStatCd?: string;
  utmId?: string; // 유틸리티매트릭스ID
  planProcId?: string; // 계획공정ID
  prdnProcCd?: string; // 생산공정
  prdnProcCdNm?: string; // 생상공정명(노출용)
  dtalProcCd?: string; // 세부공정
  dtalProcCdNm?: string; // 세부공정명(노출용)
  stndEqpId?: string; // 표준설비코드
  sumBaseCd?: string; // 집계기준

  copyUtmId?: string; // 유틸리티매트릭스ID
  copyPlanProcId?: string; // 계획공정ID
  utmNo?: string; // 유틸리티매트릭스번호(노출용)
  bildPlntCd?: string; // 건설플랜트코드
  bildPlntCds?: any;
  bildPlntCdNm?: string; // 건설플랜트코드명(노출용)
  askPurpCdNm?: string; // 의뢰목적코드명(노출용)
  verNo?: string; // 버전번호(노출용)
  dataInsDtm?: string; // 데이터입력일시(노출용)
  utmWrtProcProgStatCd?: string; // 유틸리티매트릭스작성공정진행상태코드
  utmWrtProcProgStatCdNm?: string; // 유틸리티매트릭스작성공정진행상태코드명(노출용)
  openMode?: string;
  tagIssuYn?: string; // Hookup Tagging 여부(노출용)
  eqclId?: string; // 설비군ID
  eqclNm?: string; // 설비군명
}
